exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-56b38214] {\n  margin-left: auto;\n  margin-right: 0;\n}\n.btn .svg-icon[data-v-56b38214] {\n  height: 1.8rem;\n  width: 1.8rem;\n}", ""]);

// exports
